// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_content_form-component .codex-editor {\n  background-color: var(--grayLight);\n  border-radius: 10px; }\n  .modal_content_form-component .codex-editor .codex-editor__redactor {\n    padding-bottom: 20px !important; }\n  .modal_content_form-component .codex-editor .ce-block__content {\n    max-width: 90%; }\n", ""]);
// Exports
module.exports = exports;
